import * as Yup from 'yup'

export interface ICreateContract {
  id?: number | string | undefined
  contractId?: number | string | undefined
  place: optiosContract[]
  service?: optiosContract[]
  regime?: optiosContract[]
  payrollCycle?: string
  frequencyCycle?: number | undefined
  frequencyType?: optiosContract[]
  templateType?: optiosContract[]
  minuteCycle?: string
  qtyCycle?: string
  mondayId?: string
  tuesdayId?: string
  wednesdayId?: string
  thursdayId?: string
  fridayId?: string
  saturdayId?: string
  sundayId?: string
  monday?: boolean
  tuesday: boolean
  wednesday?: boolean
  thursday?: boolean
  friday?: boolean
  saturday?: boolean
  sunday?: boolean
  quantityMonday?: number | undefined
  quantityTuesday?: number | undefined
  quantityWednesday?: number | undefined
  quantityThursday?: number | undefined
  quantityFriday?: number | undefined
  quantitySaturday?: number | undefined
  quantitySunday?: number | undefined
  homologada?: boolean
  templateHomologada?: optiosContract[]
  homologada2?: boolean
  templateHomologada2?: optiosContract[]
  weeks?: number | undefined
  fatherStructure?: optiosContract[]
  fatherStructure2?: optiosContract[]
  fatherStructure3?: optiosContract[]
  fatherStructure4?: optiosContract[]
  mainIngredients?: optiosContract[]
  mainIngredients2?: optiosContract[]
  tolerance?: optiosContract[]
  allergens?: optiosContract[]
  dietaryCategory?: optiosContract[]
  dietaryCategory2?: optiosContract[]
  dietaryCategoryAll?: optiosContract[]
  dietaryCategory3?: optiosContract[]
  structure: string
  allowsStamp?: optiosContract[]
  recipe?: optiosContract[]
  cycleWeek?: optiosContract[]
  frequency?: number | undefined
  associatedStructures?: optiosContract[]
  diaReceta?: optiosContract[]
  cycles4?: optiosContract[]
  blockedDays?: optiosContract[]
  intercalaryWeek?: optiosContract[]
  comodin?: optiosContract[]
  plateType?: optiosContract[]
  monthlyCost?: number | undefined
  fechaCreacion?: Date | undefined
  idTemplate?: string | number
  ruleColorDistribution?: boolean | undefined
  ruleRecipeRepeat?: boolean | undefined
  ruleDescriptiveCost?: boolean | undefined
  ruleGarnitureCruce?: boolean | undefined
  ruleNameRepeat?: boolean | undefined
  ruleRemoriceEfect?: boolean | undefined
  ruleComplexityRecipes?: boolean | undefined
  ruleCookingMethod?: boolean | undefined
  ruleCruceRule?: boolean | undefined
  reglaSitio?: optiosContract[]
  reglaRegimen?: optiosContract[]
  reglaServicios?: optiosContract[]
  order?: number | undefined
}

const initsContract: ICreateContract = {
  id: undefined,
  contractId: undefined,
  place: [],
  service: [],
  regime: [],
  payrollCycle: '',
  frequencyCycle: undefined,
  frequencyType: [],
  templateType: [],
  minuteCycle: '',
  qtyCycle: '',
  mondayId: '0',
  tuesdayId: '0',
  wednesdayId: '0',
  thursdayId: '0',
  fridayId: '0',
  saturdayId: '0',
  sundayId: '0',
  monday: true,
  tuesday: true,
  wednesday: true,
  thursday: true,
  friday: true,
  saturday: true,
  sunday: true,
  quantityMonday: undefined,
  quantityTuesday: undefined,
  quantityWednesday: undefined,
  quantityThursday: undefined,
  quantityFriday: undefined,
  quantitySaturday: undefined,
  quantitySunday: undefined,
  homologada: false,
  templateHomologada: [],
  homologada2: false,
  templateHomologada2: [],
  weeks: undefined,
  fatherStructure: [],
  fatherStructure2: [],
  fatherStructure3: [],
  fatherStructure4: [],
  mainIngredients: [],
  mainIngredients2: [],
  tolerance: [],
  allergens: [],
  dietaryCategory: [],
  dietaryCategory2: [],
  dietaryCategory3: [],
  structure: '',
  allowsStamp: [],
  recipe: [],
  cycleWeek: [],
  frequency: 0,
  associatedStructures: [],
  diaReceta: [],
  cycles4: [],
  blockedDays: [],
  intercalaryWeek: [],
  comodin: [],
  plateType: [],
  ruleColorDistribution: false,
  ruleRecipeRepeat: false,
  ruleDescriptiveCost: false,
  ruleGarnitureCruce: false,
  ruleNameRepeat: false,
  ruleRemoriceEfect: false,
  ruleComplexityRecipes: false,
  ruleCookingMethod: false,
  ruleCruceRule: false,
  reglaSitio: [],
  reglaRegimen: [],
  reglaServicios: [],
  order: 0,
}

const createContractSchemas = [
  Yup.object({ // step 1
    quantityMonday: Yup.number().min(0, 'Valor no supera la cantidad mínima de comensales!').max(9999, 'Valor supera la cantidad máxima de comensales!'),
    quantityTuesday: Yup.number().min(0, 'Valor no supera la cantidad mínima de comensales!').max(9999, 'Valor supera la cantidad máxima de comensales!'),
    quantityWednesday: Yup.number().min(0, 'Valor no supera la cantidad mínima de comensales!').max(9999, 'Valor supera la cantidad máxima de comensales!'),
    quantityThursday: Yup.number().min(0, 'Valor no supera la cantidad mínima de comensales!').max(9999, 'Valor supera la cantidad máxima de comensales!'),
    quantityFriday: Yup.number().min(0, 'Valor no supera la cantidad mínima de comensales!').max(9999, 'Valor supera la cantidad máxima de comensales!'),
    quantitySaturday: Yup.number().min(0, 'Valor no supera la cantidad mínima de comensales!').max(9999, 'Valor supera la cantidad máxima de comensales!'),
    quantitySunday: Yup.number().min(0, 'Valor no supera la cantidad mínima de comensales!').max(9999, 'Valor supera la cantidad máxima de comensales!'),
    // frequencyCycle: Yup.number().required('Ciclo de frecuencia es requerido'),
    // frequencyType: Yup.array().validateArray(),
    // templateType: Yup.array().nullable().validateArray(),
    // place: Yup.array().nullable().validateArray(),
    // service: Yup.array().nullable().validateArray(),
    // regime: Yup.array().nullable().validateArray(),
  }),
  Yup.object({ // step 2
    // fatherStructure: Yup.array().validateArray(),
    // tolerance: Yup.array().nullable().validateArray(),
    // dietaryCategory: Yup.array().nullable().validateArray(),
    // allergens: Yup.array().nullable().validateArray(),
    // structure: Yup.string().validateArray(),
    // allowsStamp: Yup.array().nullable().validateArray(),
  }),
  Yup.object({ // step 3
    // structure: Yup.string().required('La estructura es requerida')
    // payrollCycle: Yup.string().required('Ciclo Planilla es requerido'),
  }),
  Yup.object({ // step 4
    // structure: Yup.string().required('La estructura es requerida')
    // payrollCycle: Yup.string().required('Ciclo Planilla es requerido'),
  }),
  Yup.object({ // step 5
    // structure: Yup.string().required('La estructura es requerida')
    // payrollCycle: Yup.string().required('Ciclo Planilla es requerido'),
  }),
]
export interface optiosContract {
  text: string | number,
  value: string | number,
  tagLabel?: string | number
}
export { initsContract, createContractSchemas }

